<template>
  <section>
    <v-bottom-navigation fixed>
      <v-row justify="center" align="center">
        <v-col cols="12" md="6">
          <div class="d-flex align-center">
            <span class="mx-3 link--text" v-html="`${value}%`">0%</span>
            <v-progress-linear
              :value="`${value}%`"
              class="mx-3"
              color="teal"
              height="6"
              rounded
            ></v-progress-linear>
          </div>
        </v-col>
      </v-row>
    </v-bottom-navigation>
  </section>
</template>

<script>
export default {
  props: ['value']
}
</script>
